import React from 'react';
import SIcon from './SIcon';
import { faPlugCircleExclamation } from '@fortawesome/pro-regular-svg-icons';

const Icon = props => <SIcon {...props} icon={faPlugCircleExclamation} fa />;

export default Icon;